<template>
  <div>
    <div class="sources-overlay-header">
      <p
        class="sources-overlay-header-label"
        :style="{ ...getFontSizeForResponse('title', false) }"
      >
        Sources And Brands
      </p>
      <button
        class="sources-overlay-close-btn"
        @click.stop="handleCrossButtonClicked()"
      >
        <div class="icon">
          <BaseIcon name="CloseIcon" />
        </div>
      </button>
    </div>
    <div class="sources-overlay-body">
      <div class="content-container">
        <p
          :style="{ ...getFontSizeForResponse('bodyText', false) }"
          class="sources-overlay-content-label"
        >
          {{ multiSourceText }}
        </p>
        <ButtonGroup :buttons="getSources" />
      </div>
    </div>
  </div>
</template>

<script>
import BaseIcon from '@/views/BaseIcon.vue'
import ButtonGroup from './ButtonGroup.vue'
import fontSizeMixin from '@/mixins/fontSizeMixin'

export default {
	name: 'SourcesOverlay',
    components: {
        ButtonGroup,
        BaseIcon
    },
    mixins: [fontSizeMixin],
    computed: {
        crossIcon() {
            return `${this.$cdn}/images/cross_dark.svg`
        },
        getSources() {
            return this.$store.state.knowledgeAISourcesState?.multiSources?.sources
        },
        multiSourceText() {
            return this.$store.state.knowledgeAISourcesState?.multiSources?.multiSourceText || "Sources"
        }
    }, 
    methods: {
        handleCrossButtonClicked() {
            this.$store.dispatch('updateKnowledgeAISources', { isEnabled: false, sources: [] })
        }
    }
}
</script>
<style lang="scss" scoped>
.sources-overlay-header {
    display: flex;
    padding: 12px 20px 12px 24px;
    align-items: center;
    gap: 8px;
    border-bottom: 1px solid #E8E8E8;
    border-radius: 8px 8px 0px 0px;

    .sources-overlay-header-label {
        font-weight: 500;
    }

    .sources-overlay-close-btn {
        margin-left: auto;
        border: none;
        cursor: pointer;
        background: none;
    }
 }

 .sources-overlay-body {
    display: flex;
    padding: 24px;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
    flex: 1 0 0;
    align-self: stretch; 
    .content-container {
        width: 100%;
        .sources-overlay-content-label {
            color: #6D6D6D;
            font-weight: 600;
            margin-bottom: 10px;
        }
    }
 }
</style>
